var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.modalAction
    ? _c(
        "b-modal",
        {
          attrs: {
            id: "itemFormulaModal",
            title: _vm.modalAction.Title,
            size: "xl",
            "no-close-on-backdrop": ""
          },
          on: { show: _vm.show, hide: _vm.hide },
          scopedSlots: _vm._u(
            [
              {
                key: "modal-footer",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "w-100 text-right" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "danger", size: "sm" },
                            on: {
                              click: function($event) {
                                return _vm.close()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("index.close")) +
                                "\n        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "primary", size: "sm" },
                            on: {
                              click: function($event) {
                                return _vm.submitModal()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("index.approve")) +
                                "\n        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ],
            null,
            false,
            346486645
          )
        },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("index.ItemFormula.Code"),
                        md: "4",
                        lg: "4",
                        error: _vm.$v.form.Code
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("index.ItemFormula.Description1"),
                        md: "4",
                        lg: "4",
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("index.ItemFormula.BranchCriteria"),
                        md: "4",
                        lg: "4",
                        error: _vm.$v.form.BranchCriteriaId
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          "lookup-key": "BRANCH_CRITERIA",
                          "get-lookup": true
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedBranchType(
                              "BranchCriteriaId",
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _vm.showBranches
                ? _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("index.ItemFormula.Branch"),
                            md: "4",
                            lg: "4"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextBranch/api/Branch/Search",
                              searchable: ""
                            },
                            model: {
                              value: _vm.branch,
                              callback: function($$v) {
                                _vm.branch = $$v
                              },
                              expression: "branch"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("AddDetailButton", {
                            nativeOn: {
                              click: function($event) {
                                return _vm.addBranch($event)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("b-table", {
                            attrs: {
                              items: _vm.form.ItemFormulaBranchs,
                              fields: _vm.fields2,
                              striped: "",
                              responsive: ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "head()",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t(data.label)) +
                                          "\n            "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              128117516
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("index.ItemFormula.BeginDate"),
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("b-form-datepicker", {
                        attrs: {
                          locale: "tr",
                          placeholder: _vm.$t("insert.chooseDate")
                        },
                        model: {
                          value: _vm.BeginDate,
                          callback: function($$v) {
                            _vm.BeginDate = $$v
                          },
                          expression: "BeginDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("index.ItemFormula.EndDate"),
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("b-form-datepicker", {
                        attrs: {
                          locale: "tr",
                          placeholder: _vm.$t("insert.chooseDate")
                        },
                        model: {
                          value: _vm.EndDate,
                          callback: function($$v) {
                            _vm.EndDate = $$v
                          },
                          expression: "EndDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "ml-auto", attrs: { cols: "12", md: "2" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("AddDetailButton", {
                            nativeOn: {
                              click: function($event) {
                                return _vm.addValidDates($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.ItemFormulaValidDates
                ? _c(
                    "b-row",
                    [
                      _c("b-table", {
                        attrs: {
                          items: _vm.form.ItemFormulaValidDates,
                          fields: _vm.fields,
                          striped: "",
                          responsive: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "head()",
                              fn: function(data) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t(data.label)) +
                                      "\n          "
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(show_details)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { size: "sm" },
                                      on: { click: row.toggleDetails }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "index.ItemFormula.Descriptions"
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            row.detailsShowing
                                              ? "Gizle"
                                              : "Göster"
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { size: "sm" },
                                      on: {
                                        click: function($event) {
                                          return _vm.detailRow(row)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "index.ItemFormula.AddDescription"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                ]
                              }
                            },
                            {
                              key: "row-details",
                              fn: function(row) {
                                return [
                                  _c("b-table", {
                                    attrs: {
                                      items: row.item.ItemFormulaDetails,
                                      fields: _vm.fields1,
                                      striped: "",
                                      responsive: ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "head()",
                                          fn: function(data) {
                                            return [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(_vm.$t(data.label)) +
                                                  "\n              "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3187009608
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showValidDates
                ? _c(
                    "b-card",
                    { staticClass: "w-100" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "index.ItemFormula.FieldDescription"
                                ),
                                required: true,
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("NextDropdown", {
                                attrs: {
                                  url:
                                    "VisionNextCommonApi/api/LookupValue/GetValuesBySysParams",
                                  "dynamic-request": {
                                    paramId: "ITEM_CRITERIA"
                                  },
                                  label: "Label"
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.getItemValues($event)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t("index.ItemFormula.FieldValue"),
                                required: true,
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  options: _vm.fieldValues,
                                  label: "Label"
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setFieldDesc($event)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t("index.ItemFormula.Quantity"),
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  type: "text",
                                  value: "0.1",
                                  readonly: ""
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t("index.ItemFormula.UnitId"),
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  type: "text",
                                  value: "Karton",
                                  readonly: ""
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "index.ItemFormula.DiscountAmount"
                                ),
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.ValidDates.DiscountAmount,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.ValidDates,
                                      "DiscountAmount",
                                      $$v
                                    )
                                  },
                                  expression: "ValidDates.DiscountAmount"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t("index.ItemFormula.Currency"),
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  type: "text",
                                  value: "Türk Lirası",
                                  readonly: ""
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            [
                              _c("AddDetailButton", {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.addItemFormulaDetails($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb791688", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb791688","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Actions/ItemFormulaModal.vue
// module id = null
// module chunks = 